import { useState } from 'react';

const csrfToken = () =>
  document.querySelector('[name="csrf-token"]')?.getAttribute('content') ?? '';

/**
 * Thin wrapper around fetch for POST / PUT / DELETE admin mutations.
 *
 * @param {function} onSuccess  Called with the parsed response body on success
 * @param {function} onError    Called with the Error on failure
 */
const useAdminMutation = ({ onSuccess, onError } = {}) => {
  const [isSubmitting, setSubmitting] = useState(false);

  const mutate = async (url, { method = 'POST', body = {} } = {}) => {
    setSubmitting(true);
    try {
      const res = await window.fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken(),
        },
        body: JSON.stringify(body),
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `Request failed: ${res.status}`);
      }
      const payload = await res.json().catch(() => null);
      if (onSuccess) onSuccess(payload);
      return payload;
    } catch (err) {
      if (onError) onError(err);
      throw err;
    } finally {
      setSubmitting(false);
    }
  };

  return { mutate, isSubmitting };
};

export default useAdminMutation;
